import { useContext } from 'react';

import { AlertsDispatchContext, AlertsStateContext } from './Provider';

export const useAlertsDispatch = () =>
  useContext(AlertsDispatchContext);

export const useAlertsState = () =>
  useContext(AlertsStateContext);
